export enum EStorageMessages {
  logout,
  login,
}

// EScreenSize values depends on _media_queries.scss file

export const SCREEN_SIZE_BREAKPOINTS: Record<string, number> = {
  xs: 576,
  sm: 768,
  md: 992,
  lg: 1200,
};

Object.freeze(SCREEN_SIZE_BREAKPOINTS);

export enum EApplicationEnvironments {
  local = 'local',
  dev = 'dev',
  qa = 'qa',
  production = 'production',
}

export const localStorageMessageKey = 'app_message';
export const localStorageUrlRedirect = 'url_after_redirect';
export const agGridLicenseKey =
  'Using_this_{AG_Grid}_Enterprise_key_{AG-068796}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{LeaseHawk}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{LeaseHawk}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{LeaseHawk}_need_to_be_licensed___{LeaseHawk}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{8_October_2025}____[v3]_[01]_MTc1OTg3ODAwMDAwMA==db13e8f1db59e37848ec600853eb7e97';
